import { MapTo } from "@adobe/aem-react-editable-components";
import { AuthoringUtils } from "@adobe/aem-spa-page-model-manager";
import { LoyaltyContactForm } from "@jti/ui";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const LoyaltyContactFormConfig = {
    emptyLabel: "Please fill in consent",
    isEmpty: (props) => {
        return !props.heading || !props.subHeading || !props.title || !props.imageSrc;
    },
    getProps: (props) => {
        return {
            heading: props.heading,
            subHeading: props.subHeading,
            title: props.title,
            sendButtonLabel: props.sendButtonLabel,
            description: props.description,
            serverErrorMessage: props.serverErrorMessage,
            successScreenTitle: props.successScreenTitle,
            successHeading: props.successHeading,
            successSubHeading: props.successSubHeading,
            imageSrc: props.imageSrc,
            theme: props.theme,
            isInEditor: AuthoringUtils.isInEditor(),
            consent: props.consent,
            successFormHeading: props.successFormHeading,
            successFormSubHeading: props.successFormSubHeading,
        };
    },
};
export default MapTo("loyalty/components/loyaltyContactForm")(withAemAuthoring(LoyaltyContactForm, LoyaltyContactFormConfig));
